import { render, staticRenderFns } from "./talent_index.vue?vue&type=template&id=7babb684&scoped=true"
import script from "./talent_index.vue?vue&type=script&lang=js"
export * from "./talent_index.vue?vue&type=script&lang=js"
import style0 from "./talent_index.vue?vue&type=style&index=0&id=7babb684&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7babb684",
  null
  
)

export default component.exports